<template>
  <div>
    <spinner-loader :loadingStuff="loadingStuff" />
    <app-template />
    <div v-if="userData.name !== ''" class="uk-container uk-container-large">
      <div class="sessions-week-layout">
        <ul class="tabs">
          <li class="tab-item">
            <a :class="selectedTab === 'current-week-tab'
              ? 'tab-link active'
              : 'tab-link'
              " @click="tabChange('selectedTab', 'current-week-tab')" href="javascript:;">Your Apps</a>
          </li>

          <!-- <li class="tab-item" v-if="userData.trialistId === null">
              <a
                :class="
                  selectedTab === 'actions-tab' ? 'tab-link active' : 'tab-link'
                "
                @click="tabChange('selectedTab', 'actions-tab')"
                href="javascript:;"
              >
                <span class="number-alert" v-if="playerActionNumber > 0">{{
                  playerActionNumber
                }}</span
                >Your Actions</a
              >
            </li>-->
          <li class="tab-item" v-if="userData.userType !== 'Scout'">
            <a :class="selectedTab === 'notifications-tab'
              ? 'tab-link active'
              : 'tab-link'
              " @click="tabChange('selectedTab', 'notifications-tab')" href="javascript:;">
              <span class="number-alert" v-if="playerActionNumber > 0">{{
                playerActionNumber
              }}</span>{{ canSendNotices ? "Notifications" : "Notices" }}</a>
          </li>
        </ul>
        <div class="tabs-wrapper">
          <div class="current-week-tab tab-content" v-if="selectedTab === 'current-week-tab'">
            <!-- SportsScience (volunteer testers): Testing + their club chats,
                 nothing else. The router enforces the same list. -->
            <template v-if="userData.userType === 'SportsScience'">
              <div class="training-session-entry">
                <div class="session-content large-app">
                  <router-link :to="{ name: 'testing' }" class="uk-navbar-item uk-logo">
                    <div class="session-data">
                      <SectionIcon name="gpsReports" />
                      <h3>Physical Testing</h3>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="training-session-entry" v-if="hasFeature('realTimeChat')">
                <div class="session-content large-app">
                  <router-link :to="{ name: 'chats' }" class="uk-navbar-item uk-logo">
                    <div class="session-data">
                      <SectionIcon name="chat" />
                      <h3>Chats</h3>
                    </div>
                  </router-link>
                </div>
              </div>
            </template>
            <template v-else>
            <div v-if="userData.userType !== 'Scout'" class="training-session-entry">
              <div class="session-content large-app">
                <router-link :to="{ name: 'profile' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="boot" />
                    <h3 v-if="
                      userData.userType !== 'Admin' &&
                      userData.userType !== 'Coach' &&
                      userHasMoreThanOneAccount === null
                    ">
                      Your Profile
                    </h3>
                    <h3 v-else>Overview</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="training-session-entry" v-if="userData.userType !== 'Scout'">
              <div class="session-content large-app">
                <router-link :to="{ name: 'teams' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="teams" />
                    <h3>Teams Information</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="training-session-entry" v-if="hasFeature('nutrition') && canAccessNutrition">
              <div class="session-content large-app">
                <router-link :to="{ name: 'nutrition' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="nutrition" />
                    <h3>Nutrition</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="training-session-entry" v-if="
              hasFeature('trialists') &&
              (userData.userType === 'Admin' ||
                userData.userType === 'Scout')
            ">
              <div class="session-content large-app">
                <router-link :to="{ name: 'trialists' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="playerChange" />
                    <h3>Trialists</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="training-session-entry" v-if="hasFeature('booking')">
              <div class="session-content large-app">
                <router-link :to="{ name: 'booking' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="pitch" />
                    <h3>Schedule</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="training-session-entry" v-if="
              userData.userType === 'Admin' || userData.userType === 'Coach'
            ">
              <div class="session-content large-app">
                <router-link :to="{ name: 'coaches' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="strip" />
                    <h3>Coaches</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="training-session-entry" v-if="
              hasFeature('scouts') &&
              (userData.userType === 'Admin' || userData.userType === 'Scout')
            ">
              <div class="session-content large-app">
                <router-link :to="{ name: 'scouts' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="ball" />
                    <h3 v-if="userData.userType === 'Scout'">Your profile</h3>
                    <h3 v-else>Scouts</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="training-session-entry" v-if="hasFeature('seasonRollover') && userData.userType === 'Admin'">
              <div class="session-content large-app">
                <router-link :to="{ name: 'seasonRollover' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="strip" />
                    <h3>Season Rollover</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="training-session-entry"
              v-if="hasFeature('trainingPlans') && userData.pt_module != '0' && userData.userType !== 'Scout'">
              <div class="session-content large-app">
                <router-link v-if="
                  userData.userType === 'Admin' ||
                  userData.userType === 'Coach'
                " :to="{ name: 'ptHome' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="clock" />
                    <h3>Training plans</h3>
                  </div>
                </router-link>
                <router-link v-else :to="{ name: 'ptUserHome' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="clock" />
                    <h3>Personal Training</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="training-session-entry" v-if="
              hasFeature('documents') &&
              (userData.userType === 'Admin' || userData.userType === 'Coach')
            ">
              <div class="session-content large-app">
                <router-link :to="{ name: 'documents' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="documentlib" />
                    <h3>Documents Library</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="training-session-entry" v-if="hasFeature('realTimeChat') && userData.userType !== 'Scout'">
              <div class="session-content large-app">
                <router-link :to="{ name: 'chats' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="chat" />
                    <h3>Chats</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <!-- Match Reports / GPS reports -->
            <div class="training-session-entry" v-if="
              hasFeature('matchReports') &&
              !isGrassrootsTenant() &&
              (userData.userType === 'Admin' || userData.userType === 'Coach')
            ">
              <div class="session-content large-app">
                <router-link :to="{ name: 'matchReports' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="matchReports" />
                    <h3>Match reports</h3>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="training-session-entry" v-if="
              hasFeature('gpsReports') &&
              userData.userType !== 'User' &&
              userData.userType !== 'Scout'
            ">
              <div v-if="
                userData.userType === 'Admin' || userData.userType === 'Coach'
              ">
                <div class="session-content large-app">
                  <router-link :to="{ name: 'gpsReports' }" class="uk-navbar-item uk-logo">
                    <div class="session-data">
                      <SectionIcon name="gpsReports" />
                      <h3>GPS reports</h3>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <!-- Player/parent-facing payments: pay fees, season installments,
                 vouchers, history. Shown to everyone on payment-enabled clubs. -->
            <div class="training-session-entry" v-if="
              hasFeature('paymentProcessing') && userData.userType !== 'Scout'
            ">
              <div class="session-content large-app">
                <router-link :to="{ name: 'myPayments' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="feePlans" />
                    <h3>Payments</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="training-session-entry" v-if="
              hasFeature('returnToPlay') &&
              userData.userType !== 'Scout' && userData.userType !== 'User'
            ">
              <div class="session-content large-app">
                <router-link :to="{ name: 'returnToPlay' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="rtp" />
                    <h3>Return to Play</h3>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="training-session-entry" v-if="
              hasFeature('injuryManagement') &&
              userData.userType !== 'Scout' && userData.userType !== 'User'
            ">
              <div class="session-content large-app">
                <router-link :to="{ name: 'injuries' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="injuries" />
                    <h3>Injury Reports</h3>
                  </div>
                </router-link>
              </div>
            </div>


            <div class="training-session-entry" v-if="
              hasFeature('physioAppointments') &&
              userData.userType !== 'Scout' && userData.userType !== 'User'
            ">
              <div class="session-content large-app">
                <router-link :to="{ name: 'physioCalendar' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="physioCalendar" />
                    <h3>Physio Calendar</h3>
                  </div>
                </router-link>
              </div>
            </div>

            <!-- Book Physio Appointment - hidden from Scouts -->
            <div class="training-session-entry" v-if="hasFeature('physioAppointments') && userData.userType !== 'Scout'">
              <div class="session-content large-app">
                <router-link :to="{ name: 'bookPhysio' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="physio" />
                    <h3>Book Physio</h3>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="training-session-entry" v-if="hasFeature('appActivity') && userData.userType === 'Admin'">
                <div class="session-content large-app">
                  <router-link :to="{ name: 'reports' }" class="uk-navbar-item uk-logo">
                    <div class="session-data">
                      <SectionIcon name="appActivity" />
                      <h3>App Activity</h3>
                    </div>
                  </router-link>
                </div>
              </div>

            <!-- Physical testing (staff): same page the SportsScience role gets -->
            <div class="training-session-entry" v-if="
              hasFeature('gpsReports') &&
              (userData.userType === 'Admin' || userData.userType === 'Coach')
            ">
              <div class="session-content large-app">
                <router-link :to="{ name: 'testing' }" class="uk-navbar-item uk-logo">
                  <div class="session-data">
                    <SectionIcon name="gpsReports" />
                    <h3>Physical Testing</h3>
                  </div>
                </router-link>
              </div>
            </div>
            </template>
          </div>
          <div class="actions-tab tab-content" v-if="selectedTab === 'actions-tab'">
            <div v-if="
              userData.userType !== 'Admin' || userData.userType === 'Coach'
            " class="padding-wrapper">
              <div v-if="playerActionNumber == 0">
                <div class="empty-state">
                  <img src="../img/emptyStateIllustration.svg" />
                  <p>You have no actions, Good job!</p>
                </div>
              </div>

              <BAlert v-if="gamePerformanceData.created_date === null" :model-value="true" variant="danger">
                <p>
                  <i class="bi bi-file-text" aria-hidden="true"></i> You have
                  not submitted any Game reports - Please submit one now -
                  <router-link :to="{ name: 'profile' }">Profile</router-link>
                </p>
              </BAlert>

              <BAlert v-if="trainingPerformanceData.created_date === null" :model-value="true" variant="danger">
                <p>
                  <i class="bi bi-file-text" aria-hidden="true"></i> You have
                  not submitted any Training reports - Please submit one now -
                  <router-link :to="{ name: 'profile' }">Profile</router-link>
                </p>
              </BAlert>

              <BAlert v-if="checkDateTimeFromNow(gamePerformanceData.created_date)" :model-value="true"
                variant="danger">
                <p>
                  <i class="bi bi-file-text" aria-hidden="true"></i> You last
                  submitted a Game report on
                  {{ formatDate(gamePerformanceData.created_date) }} - Please
                  submit one now -
                  <router-link :to="{ name: 'profile' }">Profile</router-link>
                </p>
              </BAlert>

              <BAlert v-if="
                checkDateTimeFromNow(trainingPerformanceData.created_date)
              " :model-value="true" variant="danger">
                <p>
                  <i class="bi bi-file-text" aria-hidden="true"></i> You last
                  submitted a Training report on
                  {{ formatDate(trainingPerformanceData.created_date) }} -
                  Please submit one now -
                  <router-link :to="{ name: 'profile' }">Profile</router-link>
                </p>
              </BAlert>
            </div>
          </div>
          <div class="notifications-tab tab-content" v-if="selectedTab === 'notifications-tab'">
            <div class="notifications-grid">
              <div v-if="canSendNotices" class="notify-card">
                <h3 class="notify-card__title">Send a message</h3>

                <div class="form__item">
                  <span class="form__label">Delivery method</span>
                  <div class="channel-options">
                    <label class="channel-option" :class="{ selected: notification.type === 'Notification' }">
                      <input type="radio" v-model="notification.type" value="Notification"
                        name="notifications-radios" />
                      <span class="channel-option__name">
                        <i class="bi bi-phone" aria-hidden="true"></i> App notification
                      </span>
                      <span class="channel-option__hint">Push message to phones</span>
                    </label>
                    <label class="channel-option" :class="{ selected: notification.type === 'Email' }">
                      <input type="radio" v-model="notification.type" value="Email" name="notifications-radios" />
                      <span class="channel-option__name">
                        <i class="bi bi-envelope" aria-hidden="true"></i> Email
                      </span>
                      <span class="channel-option__hint">Delivered to inboxes</span>
                    </label>
                  </div>
                </div>

                <div class="form__item">
                  <label class="form__label" for="notify_title">Title</label>
                  <b-form-input id="notify_title" v-model="notification.title" maxlength="80"></b-form-input>
                  <p class="field-hint" v-if="notification.type === 'Notification'">
                    Keep it short — phones truncate titles around 50 characters.
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="notify_message">Message</label>
                  <b-form-textarea id="notify_message" v-model="notification.message" rows="5"
                    max-rows="12"></b-form-textarea>
                </div>

                <div class="form__item">
                  <b-form-checkbox id="emergencyNotification" v-model="notification.emergency"
                    name="emergencyNotification" value="1" unchecked-value="0" class="emergency-check" :class="{
                      armed:
                        notification.emergency === '1' ||
                        notification.emergency === 1,
                    }">
                    <i class="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
                    Emergency — high priority
                  </b-form-checkbox>
                </div>

                <div class="form__item" v-if="notification.type !== 'Email'">
                  <b-form-checkbox id="postToChats" v-model="notification.postToChats" name="postToChats"
                    value="1" unchecked-value="0">
                    Also post it in the team chats
                  </b-form-checkbox>
                  <small class="form__hint">A push disappears once it's swiped away — this leaves the message in each
                    team's main chat, and everyone can always find it under Notices on their home screen.</small>
                </div>

                <div class="form__item" v-if="userData.userType === 'Admin'">
                  <b-form-checkbox @change="onEveryoneToggle($event)" id="sendToEveryone" v-model="notification.all"
                    name="sendToEveryone" value="1" unchecked-value="0">Send to everyone in the club
                  </b-form-checkbox>
                </div>

                <div class="form__item" v-if="notification.all !== '1' && notification.all !== 1">
                  <span class="form__label">
                    Select team(s)
                    <span class="selected-count" v-if="listOfSelectedTeamIds.length > 0">{{
                      listOfSelectedTeamIds.length }} selected</span>
                  </span>

                  <div class="team-choices">
                    <label class="team-choice" v-for="team in clubTeams" :key="team.id"
                      :for="`notify-team-${team.id}`"
                      :class="{ selected: listOfSelectedTeamIds.includes(String(team.id)) }">
                      <input @change="teamIdsAddRemove($event)" type="checkbox" :id="`notify-team-${team.id}`"
                        :name="team.teamName" :value="team.id"
                        :checked="listOfSelectedTeamIds.includes(String(team.id))" />
                      {{ team.teamName }}
                    </label>
                  </div>
                </div>

                <b-button class="notify-send" :variant="notification.emergency === '1' || notification.emergency === 1
                  ? 'danger'
                  : 'success'
                  " :disabled="loadingStuff" @click="sendNotification()">
                  {{
                    loadingStuff
                      ? "Sending…"
                      : notification.emergency === "1" || notification.emergency === 1
                        ? "Send emergency notification"
                        : "Send notification"
                  }}
                </b-button>
              </div>

              <div v-if="!canSendNotices" class="notify-card notifications-history">
                <h3 class="notify-card__title">Club notices</h3>

                <p v-if="myNotices.length === 0" class="history-empty">
                  No notices in the last 90 days.
                </p>

                <div v-else class="scroll-wrapper">
                  <div class="history-list" :class="{ 'is-emergency': item.is_emergency == 1 }"
                    v-for="item in myNotices" :key="item.id">
                    <p class="date">
                      {{ formatDateTime(item.sent_date) }}
                      <span v-if="item.is_emergency == 1" class="badge-emergency">EMERGENCY</span>
                    </p>
                    <p class="title">{{ item.title }}</p>
                    <p class="body">{{ item.body }}</p>
                    <p class="meta" v-if="item.sent_by">From {{ item.sent_by }}</p>
                  </div>
                </div>
              </div>

              <div v-else class="notify-card notifications-history">
                <h3 class="notify-card__title">History</h3>

                <p v-if="notificationHistory.length === 0" class="history-empty">
                  Nothing has been sent yet.
                </p>

                <div v-else class="scroll-wrapper">
                  <div class="history-list" :class="{ 'is-emergency': item.is_emergency == 1 }"
                    v-for="item in notificationHistory" :key="item.id">
                    <p class="date">
                      {{ formatDate(item.sent_date) }}
                      <span v-if="item.is_emergency == 1" class="badge-emergency">EMERGENCY</span>
                      <span class="badge-channel">{{ item.channel === "email" ? "Email" : "App" }}</span>
                    </p>
                    <p class="title">{{ item.title }}</p>
                    <p class="body">{{ item.body }}</p>
                    <p class="meta">
                      <span v-if="item.sent_by">By {{ item.sent_by }}</span>
                      <span v-if="item.channel !== 'email' && item.total_tokens != null">
                        · {{ item.successful_deliveries }}/{{ item.total_tokens }} delivered</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <template v-else>
      <div class="big-message">
        <h2>Please fill out your Player profile to get started.</h2>
        <button class="green-button">Create Player profile </button>
      </div>
    </template>-->
    <b-modal v-if="showPlayerProfileModal" v-model="showPlayerProfileModal" class="full-screen-modal" size="lg"
      title="Create your player profile" :no-close-on-backdrop="true" :hide-footer="true">
      <p>Welcome {{ userData.name }}</p>
      <p>
        To get you fully onboarded. We need you to fill out your Player profile
        / bio and self assessment.
      </p>
      <form class="form" @submit.prevent="createPlayerProfile()">
        <section class="player-profile-part-one" v-if="playerProfileForm.sectionOne === true">
          <h3>More Details</h3>
          <div class="form__item">
            <label class="form__label" for="imageURL">Upload image</label>
            <input accept="image/jpeg|image/jpg|image/heic|.jpeg"
              @change="imageChange($event, 'imageFile', 'image', 'fileOne')" type="file" class="form__input"
              ref="fileOne" id="imageURL" />
          </div>
          <div class="form__item">
            <label class="form__label" for="name">Full Name</label>
            <input type="text" v-model="playerProfileData.name" id="name" />
          </div>

          <div class="form__item">
            <label class="form__label" for="email">Email Address</label>
            <input type="email" v-model="playerProfileData.email" id="email" />
          </div>

          <div class="form__item uk-form dob">
            <label class="form__label" for="dob">DOB</label>
            <VueDatePicker :locale="'en-GB'" v-model="playerProfileData.dob" name="dob" id="dob"
              :enable-time-picker="false" format="dd/MM/yyyy" />
          </div>

          <div class="form__item">
            <label class="form__label" for="coachSelect">Select coach</label>
            <select v-model="playerProfileData.coachId" id="coachSelect">
              <option disabled value="">Please select a coach</option>
              <option v-for="coach in coachData" :value="coach.id" :key="coach.id">
                {{ coach.name }}
              </option>
            </select>
          </div>

          <div class="form__item">
            <label class="form__label" for="position">Position</label>
            <select id="position" v-model="playerProfileData.position">
              <option disabled value="">Please select a position</option>
              <option value="Goalkeeper">Goalkeeper</option>
              <option value="Right Full-back (Wingback)">
                Right Full-back (Wingback)
              </option>
              <option value="Left Full-back (Wingback)">
                Left Full-back (Wingback)
              </option>
              <option value="Center-back left">Center-back left</option>
              <option value="Center-back right">Center-back right</option>
              <option value="Defensive Midfielder">Defensive Midfielder</option>
              <option value="Centre midfield">Centre midfield</option>
              <option value="Centre Defensive Midfield">
                Centre Defensive Midfield
              </option>
              <option value="Right Midfielder (Winger)">
                Right Midfielder (Winger)
              </option>
              <option value="Left Midfielder (Winger)">
                Left Midfielder (Winger)
              </option>
              <option value="Attacking Midfielder">Attacking Midfielder</option>
              <option value="Center Forward (Striker) left">
                Center Forward (Striker) left
              </option>
              <option value="Center Forward (Striker) right">
                Center Forward (Striker) right
              </option>
            </select>
          </div>
        </section>

        <section v-if="playerProfileForm.sectionTwo === true">
          <h3>Your Profile</h3>
          <div class="form__item">
            <label class="form__label" for="name">Height</label>
            <input type="text" v-model="playerProfileData.height" id="name" />
          </div>

          <div class="form__item">
            <label class="form__label" for="foot-radios">Preferred foot</label>
            <div class="radio-group-flex">
              <b-form-radio v-model="playerProfileData.foot" name="foot-radios" value="Right">Right</b-form-radio>
              <b-form-radio v-model="playerProfileData.foot" name="foot-radios" value="Left">Left</b-form-radio>
              <b-form-radio v-model="playerProfileData.foot" name="foot-radios" value="Both">Both</b-form-radio>
            </div>
          </div>
        </section>

        <section v-if="playerProfileForm.sectionThree === true">
          <p class="more-chat">
            Tell us more about the teams you have played for.
          </p>
          <h3>Playing History / awards, previous tournaments</h3>

          <div class="form__item">
            <label class="form__label" for="name">Information</label>
            <QuillEditor v-model:content="playerProfileData.history" contentType="html" />
          </div>
        </section>

        <section v-if="playerProfileForm.sectionFour === true">
          <p class="more-chat">
            Tell us more about any other footballing qualifcations or
            experixances you have had.
          </p>
          <h3>Football Experience / courses</h3>

          <div class="form__item">
            <label class="form__label" for="name">Information</label>
            <QuillEditor v-model:content="playerProfileData.courses" contentType="html" />
          </div>
        </section>

        <section v-if="playerProfileForm.sectionFive === true">
          <p class="more-chat">
            Tell us about any dietary requierments you have, like allages etc..
          </p>
          <h3>Nutrition requierments</h3>

          <div class="form__item">
            <label class="form__label" for="name">Information</label>
            <b-form-textarea id="textarea" v-model="playerProfileData.nutrition" placeholder="Enter something..."
              rows="3" max-rows="6"></b-form-textarea>
          </div>
        </section>

        <section v-if="playerProfileForm.sectionSix === true">
          <p class="more-chat">
            Tell us about what else you like to do in your spare time.
          </p>
          <h3>Interests</h3>

          <div class="form__item">
            <label class="form__label" for="name">Information</label>
            <b-form-textarea id="textarea" v-model="playerProfileData.interests" placeholder="Enter something..."
              rows="3" max-rows="6"></b-form-textarea>
          </div>
        </section>

        <section v-if="playerProfileForm.sectionSeven === true">
          <p class="more-chat">We need to ask :-).</p>
          <h3>Discipline reds / yellow / bans</h3>

          <div class="form__item">
            <label class="form__label" for="name">Information</label>
            <b-form-textarea id="textarea" v-model="playerProfileData.discipline" placeholder="Enter something..."
              rows="3" max-rows="6"></b-form-textarea>
          </div>
        </section>

        <section v-if="playerProfileForm.sectionEight === true">
          <p class="more-chat">Do you have any football videos or reels?</p>
          <h3>Football Highlight Videos</h3>

          <div class="form__item">
            <label class="form__label" for="name">Information</label>
            <b-form-textarea id="textarea" v-model="playerProfileData.videos" placeholder="Enter something..." rows="3"
              max-rows="6"></b-form-textarea>
          </div>
        </section>

        <div class="buttons-flex">
          <button @click="formSectionsMove('back')" class="green-button">
            <i class="bi bi-arrow-left" aria-hidden="true"></i> Back
          </button>

          <button v-if="playerProfileForm.sectionEight === true" @click="formSectionsMove('next')" class="green-button">
            Save
          </button>
          <button v-else @click="formSectionsMove('next')" class="green-button">
            Next <i class="bi bi-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
      </form>
    </b-modal>

    <b-modal v-if="showWebPermissionsModal" v-model="showWebPermissionsModal" size="lg"
      title="Push notifications permissions" :hide-footer="true">
      <h2>Permissons</h2>
      <p>
        We would love to send you push notifications on team events and other
        amazing stuff.
      </p>

      <button @click="requestPermission()" class="green-button">
        Allow notifications
      </button>
    </b-modal>

    <b-modal v-if="showMessageModal" v-model="showMessageModal" size="lg" title="Message" :hide-footer="true">
      <h2>{{ currentMessage.notification.title }}</h2>
      <p>
        {{ currentMessage.notification.body }}
      </p>
    </b-modal>

    <b-modal v-if="showNotificationsNotSupportedModal" v-model="showNotificationsNotSupportedModal" size="lg"
      title="Push Notifications" :hide-footer="true" modal-class="notifications-modal" centered>
      <div class="notifications-modal-content">
        <div class="notifications-modal-header">
          <div class="notifications-modal-icon notifications-modal-icon--warning">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <h3 class="notifications-modal-title">Browser Not Supported</h3>
          <p class="notifications-modal-subtitle" v-if="isOldIOSDevice()">
            Push notifications require iOS 16.4 or later. Please update your
            {{ isIPhone() ? 'iPhone' : 'iPad' }} to receive notifications.
          </p>
          <p class="notifications-modal-subtitle" v-else>
            Your current browser doesn't support push notifications.
            Please try using a modern browser like Chrome, Firefox, or Safari.
          </p>
        </div>

        <div class="notifications-modal-info">
          <div class="notifications-info-item" v-if="isOldIOSDevice()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
              <line x1="12" y1="18" x2="12.01" y2="18" />
            </svg>
            <span>Go to <strong>Settings → General → Software Update</strong></span>
          </div>
          <div class="notifications-info-item" v-else>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            <span>Supported browsers: Chrome, Firefox, Edge, Safari 16.4+</span>
          </div>
        </div>

        <div class="notifications-modal-actions">
          <button @click="showNotificationsNotSupportedModal = false"
            class="notifications-modal-btn notifications-modal-btn--primary">
            Got It
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal v-if="showGrantPermissionsModal" v-model="showGrantPermissionsModal" size="lg" title="Message"
      :hide-footer="true">
      <h2>Please allow notifications</h2>
      <p>
        Your current browser has notifications blocked. Please grant access to
        this app so you can access all the features of the app and receive
        notifications.
      </p>

      <a href="https://support.google.com/chrome/answer/3220216?hl=en-GB&co=GENIE.Platform%3DAndroid">Chrome browser</a>
      <a
        href="https://support.apple.com/en-gb/guide/safari/sfri40734/mac#:~:text=website%20notifications%20appear-,On%20your%20Mac%2C%20choose%20Apple%20menu%20%3E%20System%20Settings%2C%20then,may%20need%20to%20scroll%20down.)&text=settings%20for%20me-,Go%20to%20Application%20Notifications%20on%20the%20right%2C%20click%20the%20website,alert%20style%20and%20other%20settings.">Safari
        browser</a>
      <a href="https://support.mozilla.org/en-US/kb/push-notifications-firefox">FireFox browser</a>
    </b-modal>

    <!-- iOS Home Screen Prompt Modal -->
    <b-modal v-if="showIOSHomeScreenPromptModal" v-model="showIOSHomeScreenPromptModal" size="lg"
      title="Get Push Notifications" :hide-footer="true" modal-class="ios-home-screen-modal" centered>
      <div class="ios-prompt-content">
        <div class="ios-prompt-header">
          <div class="ios-prompt-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
              stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
              <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
          </div>
          <h3 class="ios-prompt-title">Enable Push Notifications</h3>
          <p class="ios-prompt-subtitle">
            To receive push notifications on your {{ isIPhone() ? 'iPhone' : 'iPad' }},
            you need to add this app to your Home Screen first.
          </p>
        </div>

        <div class="ios-prompt-steps">
          <div class="ios-step">
            <div class="ios-step-number">1</div>
            <div class="ios-step-content">
              <p class="ios-step-text">
                Tap the <strong>Share</strong> button
                <svg class="ios-share-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                  viewBox="0 0 24 24" fill="none" stroke="#007AFF" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                  <polyline points="16 6 12 2 8 6" />
                  <line x1="12" y1="2" x2="12" y2="15" />
                </svg>
                {{ getShareButtonLocation() }}
              </p>
            </div>
          </div>

          <div class="ios-step">
            <div class="ios-step-number">2</div>
            <div class="ios-step-content">
              <p class="ios-step-text">
                Scroll down and tap <strong>"Add to Home Screen"</strong>
              </p>
            </div>
          </div>

          <div class="ios-step">
            <div class="ios-step-number">3</div>
            <div class="ios-step-content">
              <p class="ios-step-text">
                Tap <strong>"Add"</strong> in the top right corner
              </p>
            </div>
          </div>

          <div class="ios-step">
            <div class="ios-step-number">4</div>
            <div class="ios-step-content">
              <p class="ios-step-text">
                Open the app from your Home Screen to enable notifications
              </p>
            </div>
          </div>
        </div>

        <div class="ios-prompt-note">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
          <span>Adding to Home Screen also gives you a full-screen app experience!</span>
        </div>

        <div class="ios-prompt-actions">
          <button @click="handleIOSPromptAddedToHomeScreen()" class="ios-prompt-btn ios-prompt-btn-primary">
            I've Added It - Continue
          </button>
          <button @click="handleIOSPromptDismiss()" class="ios-prompt-btn ios-prompt-btn-secondary">
            Continue Without Notifications
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import {
  CHECK_PROFILE_HAS_DATA,
  USER_POPULATE,
  POPULATE_COACHES_USER_DATA,
} from "@/store/actions/user.js";
import { Users } from "@/services/user-service.js";
import { Games } from "@/services/games-service.js";
import { Teams } from "@/services/teams-service.js";
import { Chat } from "@/services/ChatService.js";
import { Mail } from "@/services/mail-service.js";
import AppTemplate from "../layouts/App";
import SpinnerLoader from "../../components/LoadingSpinning";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import extendSeasonEndDateToFullYearMixin from "@/mixin/extendSeasonEndDateToFullYear.js";
import moment from "moment";
import checkIfUserHasMoreThanOneAccountMixin from "@/mixin/checkIfUserHasMoreThanOneAccount.js";
import iosDetectionMixin from "@/mixin/iosDetection.js";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import SectionIcon from "@/components/SectionIcon/index.vue";
import { getNutritionAccess } from "@/composables/useNutritionAccess";
import { isFeatureEnabled, isCalendarSeason, isGrassroots } from "@/config/tenant";

export default {
  name: "Dashboard",
  components: {
    AppTemplate,
    SpinnerLoader,
    VueDatePicker,
    QuillEditor,
    SectionIcon,
  },
  mixins: [
    checkIfUserHasMoreThanOneAccountMixin,
    extendSeasonEndDateToFullYearMixin,
    iosDetectionMixin,
  ],
  data() {
    return {
      // Modal visibility states
      showPlayerProfileModal: false,
      showWebPermissionsModal: false,
      showMessageModal: false,
      showNotificationsNotSupportedModal: false,
      showGrantPermissionsModal: false,
      showIOSHomeScreenPromptModal: false,

      season_start_date: null,
      season_end_date: null,
      currentMessage: {
        notification: {
          title: "",
          body: "",
        },
      },
      clubTeams: [],
      listOfSelectedTeamIds: [],
      listOfSelectedTeamIdsToRemove: [],
      listOfSelectedYear: [],
      listOfSelectedYearToRemove: [],
      notification: {
        type: "Notification",
        title: "",
        message: "",
        all: 0,
        emergency: 0,
        postToChats: "1",
      },
      userHasMoreThanOneAccount: null,
      gamePerformanceData: {
        created_date: null,
      },
      trainingPerformanceData: {
        created_date: null,
      },
      playerProfileFormSelection: "sectionOne",
      playerProfileForm: {
        sectionOne: true,
        sectionTwo: false,
        sectionThree: false,
        sectionFour: false,
        sectionFive: false,
        sectionSix: false,
        sectionSeven: false,
        sectionEight: false,
      },
      notificationHistory: [],
      myNotices: [],
      coachData: [],
      playerProfileData: {},
      playerHasProfile: false,
      publicPath: process.env.BASE_URL,
      loadingStuff: false,
      selectedUserValue: "",
      weeklyDate: "",
      userData: {
        name: "",
        userType: "",
      },
      coachesUsersData: [],
      selectedTab: "current-week-tab",
      currentPlayingSeason: null,
      weekSelectedNumber: "",
      playerActionNumber: null,
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(["getProfile"]),
    isDevelopment() {
      return process.env.NODE_ENV === "development";
    },
    /** Admins and coaches send notices; everyone else reads them. */
    canSendNotices() {
      return (
        this.userData.userType === "Admin" ||
        this.userData.userType === "Coach"
      );
    },
    canManageExercises() {
      if (!this.userData) return false;
      const allowedRoles = ['Admin', 'Head Physio', 'Head Sports Science', 'Physio', 'Sports Science', 'HeadCoach', 'Coach'];
      return allowedRoles.includes(this.userData.userType) || allowedRoles.includes(this.userData.position);
    },
    // Nutrition tile rollout: staff only for now. Foundation-phase players
    // (U11–U15) are never granted access — welfare guardrail. See
    // useNutritionAccess.js. Widen to Performance players (isStaff || isPerformance)
    // once the SFA content is signed off and the player view uses floor framing.
    canAccessNutrition() {
      return getNutritionAccess(this.getProfile || this.userData).isStaff;
    },
  },
  created() {
    this.loadingStuff = true;
    this.weekSelectedNumber = moment().isoWeek();
    this.userHasMoreThanOneAccount = this.checkIfUserHasMoreThanOneAccount();
    this.$store.dispatch(CHECK_PROFILE_HAS_DATA).then((response) => {
      if (response === true) {
        this.setUser();
        this.getUserById(this.userData.id);
        //this.checkPlayerHasProfile();
        if (
          this.userData.userType !== "Admin" &&
          this.userData.userType !== "Coach" &&
          this.userHasMoreThanOneAccount === null
        ) {
          this.getTeamsDataById(this.userData.teamId);
          this.setPlayingSeasion();
        }
        this.getTeamsByUserId();
        this.loadingStuff = false;
      } else {
        const clientId = JSON.parse(
          localStorage.getItem("the_w_selectedClientId"),
        );
        this.getUserById(clientId).then((response) => {
          if (response === true) {
            this.selectedUserValue = clientId;
            if (
              this.userData.userType !== "Admin" &&
              this.userData.userType !== "Coach" &&
              this.userHasMoreThanOneAccount === null
            ) {
              this.getTeamsDataById(this.userData.teamId);
              this.setPlayingSeasion();
            }
            //this.checkPlayerHasProfile();
          }
          this.getTeamsByUserId();
          this.loadingStuff = false;
        });
      }
    });
    // Senders see the full send-log; everyone else sees their own notices.
    if (this.canSendNotices) {
      this.getNotificationHistory();
    } else if (this.userData.userType !== "Scout") {
      this.getMyNotices();
    }
  },
  mounted() {
    this.checkPermisson();
    this.setSeasionStartAndEndDates();
  },
  methods: {
    // Tier gating: tiles are shown only when the tenant's tier/config enables
    // the feature (see config/tiers.json). Role checks still apply on top.
    hasFeature(feature) {
      return isFeatureEnabled(feature);
    },
    // Grassroots clubs still use the per-game self-assessment (via a player's
    // profile), but don't need the coach-facing Match reports tile/section on
    // the dashboard.
    isGrassrootsTenant() {
      return isGrassroots();
    },
    async setSeasionStartAndEndDates() {
      const data = {
        action: "getCurrentPlayingSeason",
        // Scope to this club — the DB is shared across tenants, so an
        // unscoped call resolves an arbitrary club's season window.
        clubId: this.userData?.clubId || this.getProfile?.clubId,
      };
      const response = await Teams.find(data).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        // Always stash the live current-season window so the global season
        // selector can restore it after browsing a past season.
        localStorage.setItem(
          "liveSeasonStartDate",
          response.data.season_start_date,
        );
        localStorage.setItem(
          "liveSeasonEndDate",
          response.data.season_end_date,
        );

        // While viewing a past season, leave the effective window untouched
        // so a reload doesn't snap the app back to the current season.
        if (localStorage.getItem("selectedSeasonYear")) {
          return;
        }

        localStorage.setItem(
          "currentPlayingseasonStartDate",
          response.data.season_start_date,
        );
        localStorage.setItem(
          "currentPlayingseasonEndDate",
          response.data.season_end_date,
        );
        ((this.season_start_date = response.data.season_start_date),
          (this.season_end_date = response.data.season_end_date));
      }
    },
    async getNotificationHistory() {
      const data = {
        action: "getNotificationHistory",
        clubId: this.userData.clubId,
      };
      const response = await Chat.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.status === 200) {
        this.notificationHistory = response.data;
      }
    },
    async sendFBNotificationMessage() {
      const data = {
        action: "sendFBNotificationMessage",
        title: this.notification.title,
        body: this.notification.message,
        link: `${window.location.origin}/login`,
        age_group: this.listOfSelectedYear,
        clubId: this.userData.clubId,
      };
      const responce = await Chat.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.$toast.info("Notification sent", {
          title: "Notification sent",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.getNotificationHistory();

        this.notification = {
          title: "",
          message: "",
          age_group: "0000",
        };
      }
    },
    showBrowserDoesNotSupportNotificationsModal() {
      this.showNotificationsNotSupportedModal = true;
    },
    handleIOSPromptAddedToHomeScreen() {
      // User claims they added it - close modal and proceed with permission check
      this.showIOSHomeScreenPromptModal = false;
      // If they're now in standalone mode, proceed with normal flow
      if (this.isStandalone()) {
        this.requestPermission();
      } else {
        // Still not in standalone mode - they need to open from Home Screen
        this.$toast.info(
          "Please open the app from your Home Screen to enable notifications",
          {
            toaster: "b-toaster-bottom-center",
            autoHideDelay: 5000,
          }
        );
      }
    },
    handleIOSPromptDismiss() {
      // User chose to continue without notifications - permanently dismiss
      this.dismissIOSPrompt();
      this.showIOSHomeScreenPromptModal = false;
      this.$toast.info(
        "You can enable notifications later in Settings",
        {
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000,
        }
      );
    },
    async sendPushNotification(currentToken) {
      this.loadingStuff = true;
      const data = {
        action: "sendNotificationBackend",
        name: this.userData.name,
        message: this.notification.message,
        sendToAll: this.notification.all,
        idsList: this.listOfSelectedTeamIds,
        link: `${window.location.origin}/login`,
        deviceToken: currentToken,
      };

      await Mail.find(data).catch((error) => {
        console.log(error);
      });
    },
    checkPermisson() {
      // First check if this is an old iOS device that can't support PWA push
      if (this.isOldIOSDevice()) {
        console.log("Old iOS detected (< 16.4) - showing unsupported message");
        this.showBrowserDoesNotSupportNotificationsModal();
        return;
      }

      // Check if this is iOS Safari that needs to be added to Home Screen
      if (this.shouldShowIOSHomeScreenPrompt()) {
        console.log("iOS Safari detected - showing Home Screen prompt");
        this.showIOSHomeScreenPromptModal = true;
        return;
      }

      if (
        navigator.serviceWorker &&
        window.PushManager &&
        window.Notification
      ) {
        console.log("the device supports the Web Push API");
        this.requestPermission();
      } else {
        // the device does not support the Web Push API
        console.log("the device does not support the Web Push API");
        this.showBrowserDoesNotSupportNotificationsModal();
      }
    },
    showWebPushPermissionsModel() {
      this.showWebPermissionsModal = true;
    },
    async saveCurrentFBPermissionsToken(token) {
      const data = {
        action: "sendNotifsaveCurrentFBPermissionsTokenicationBackend",
        token: token,
        userId: this.userData.id,
        age_group: this.userData.age_group,
        clubId: this.userData.clubId,
      };

      console.log("FCM: Saving token to backend for userId:", this.userData.id, "clubId:", this.userData.clubId);
      try {
        const response = await Chat.find(data);
        console.log("FCM: Token save response:", response.status, response.data);
      } catch (error) {
        console.error("FCM: Failed to save token to backend:", error);
      }
      this.showWebPermissionsModal = false;
    },
    async requestPermission() {
      console.log("FCM: requestPermission() called");
      Notification.requestPermission().then((permission) => {
        console.log("FCM: Notification permission result:", permission);
        if (permission === "granted") {
          const messaging = getMessaging();
          console.log("FCM: getMessaging() succeeded");

          onMessage(messaging, (payload) => {
            console.log("Message received. ", payload);
            this.currentMessage = payload;
            this.showMessageModal = true;
          });
          getToken(messaging, {
            vapidKey:
              "BKjh5WgXQ98IFuUQ2h8dWrAv96RfO4Wqa8zyaQ3v9Eeg11qYNUQA1wMjBh-56gXcGu-Z0uPSWGc0jLMntioXWx8",
          })
            .then((currentToken) => {
              if (currentToken) {
                console.log("FCM: Got token:", currentToken.substring(0, 20) + "...");
                this.saveCurrentFBPermissionsToken(currentToken);
              } else {
                console.warn("FCM: No token returned - showing permission UI");
                this.showWebPushPermissionsModel();
              }
            })
            .catch((err) => {
              console.error("FCM: Error getting token:", err);
            });
        } else {
          console.log("FCM: Permission denied:", permission);
          this.showGrantPermissionsModal = true;
        }
      });
    },
    addTolistOfSelectedTeamIds(id) {
      this.listOfSelectedTeamIds.push(id);
      this.listOfSelectedTeamIdsToRemove =
        this.listOfSelectedTeamIdsToRemove.filter((item) => item !== id);
    },
    addToListOfSelectedTeamAgeGroups(year) {
      const yearMap = {
        2009: "2010",
        2007: "2008",
      };

      const newYear = yearMap[year] || year;

      if (!this.listOfSelectedYear.includes(newYear)) {
        this.listOfSelectedYear.push(newYear);

        if (year === "2007") {
          this.listOfSelectedYear.push("2007");
        }

        if (year === "2009") {
          this.listOfSelectedYear.push("2009");
        }
      }
    },
    removeFromlistOfSelectedTeamIds(id) {
      this.listOfSelectedTeamIdsToRemove.push(id);
      this.listOfSelectedTeamIds = this.listOfSelectedTeamIds.filter(
        (item) => item !== id,
      );
    },
    removeFromListOfSelectedAgeGroups(year) {
      const yearMap = {
        2009: "2010",
        2007: "2008",
      };

      const yearToRemove = yearMap[year] || year;
      this.listOfSelectedYear = this.listOfSelectedYear.filter(
        (item) => item !== year && item !== yearToRemove,
      );
    },
    ageGroupClear(data) {
      if (data === "1") {
        this.listOfSelectedYear = [];
      }
    },
    ageGroupAddRemove(data) {
      data.target.checked === true
        ? this.addToListOfSelectedTeamAgeGroups(data.target.value)
        : this.removeFromListOfSelectedAgeGroups(data.target.value);
    },
    teamIdsAddRemove(data) {
      data.target.checked === true
        ? this.addTolistOfSelectedTeamIds(data.target.id)
        : this.removeFromlistOfSelectedTeamIds(data.target.id);
    },
    sendNotification() {
      const all = this.notification.all === "1" || this.notification.all === 1;
      const emergency =
        this.notification.emergency === "1" || this.notification.emergency === 1;

      if (!this.notification.title || !this.notification.message) {
        this.$toast.error("Add a title and a message first");
        return;
      }
      // Never silently broadcast: require a team selection unless "everyone".
      if (!all && this.listOfSelectedTeamIds.length === 0) {
        this.$toast.error(
          "Select at least one team, or tick 'Send to everyone'",
        );
        return;
      }
      // Confirm high-impact sends (all-club and/or emergency).
      if (all || emergency) {
        const who = all
          ? "EVERYONE in the club"
          : `${this.listOfSelectedTeamIds.length} selected team(s)`;
        const msg = `Send ${emergency ? "an EMERGENCY " : ""}notification to ${who}?`;
        if (!window.confirm(msg)) return;
      }

      this.notification.type === "Email"
        ? this.sendNotificationEmails()
        : this.sendNotificationBackend();
    },
    onEveryoneToggle(value) {
      // Ticking "everyone" clears the team selection so the two targeting
      // modes can't conflict.
      if (value === "1") {
        this.listOfSelectedTeamIds = [];
      }
    },
    resetNotificationsData() {
      this.notification = {
        type: "Notification",
        title: "",
        message: "",
        all: 0,
        emergency: 0,
        postToChats: "1",
      };

      this.listOfSelectedTeamIds = [];
    },
    async sendNotificationBackend() {
      this.loadingStuff = true;
      const data = {
        action: "sendBroadcastNotification",
        title: this.notification.title,
        body: this.notification.message,
        teamIds: this.listOfSelectedTeamIds,
        sendToAll: this.notification.all,
        emergency: this.notification.emergency,
        postToChats: this.notification.postToChats,
        senderName: this.userData.name,
        senderId: this.userData.id,
        clubId: this.userData.clubId,
      };
      const response = await Chat.find(data).catch((error) => {
        console.log(error);
      });
      this.loadingStuff = false;
      if (response && response.status === 200) {
        const chats = Number(response.data?.chats_posted || 0);
        this.$toast.info(
          chats > 0
            ? `Notification sent and posted in ${chats} team chat${chats === 1 ? "" : "s"}`
            : "Notification sent",
          {
          title: "Notification sent",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
        this.getNotificationHistory();
        this.resetNotificationsData();
      }
    },
    async sendNotificationEmails() {
      this.loadingStuff = true;
      const data = {
        action: "emailNotification",
        name: this.userData.name,
        senderName: this.userData.name,
        title: this.notification.title,
        message: this.notification.message,
        sendToAll: this.notification.all,
        emergency: this.notification.emergency,
        teamIds: this.listOfSelectedTeamIds,
        senderId: this.userData.id,
        clubId: this.userData.clubId,
      };
      const responce = await Mail.find(data).catch((error) => {
        console.log(error);
      });

      this.loadingStuff = false;

      if (responce && responce.status === 200) {
        this.$toast.info("Notification sent", {
          title: "Notification sent",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
        this.getNotificationHistory();
        this.resetNotificationsData();
      }
    },
    async getTeamsByUserId() {
      this.userHasMoreThanOneAccount === null;
      const data = {
        action: "getTeamsDataById",
        userId: this.userData.id,
      };

      if (
        this.userData.userType === "Admin" ||
        this.userData.userType === "Coach"
      ) {
        data.clubId = this.userData.clubId;
      }
      const responce = await Teams.find(data).catch((error) => {
        console.log(error);
      });
      this.clubTeams = responce.data;
    },
    async getTeamsDataById(teamId) {
      const userData = {
        id: teamId,
        action: "getTeamDataById",
      };

      if (
        this.userData.userType === "Admin" ||
        this.userData.userType === "Coach"
      ) {
        userData.clubId = this.userData.clubId;
      }
      const responce = await Teams.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data !== null) {
        if (Object.keys(responce.data).length !== 0) {
          // Don't clobber a past-season override (set by the global season selector).
          if (!localStorage.getItem("selectedSeasonYear")) {
            localStorage.setItem(
              "currentPlayingseasonStartDate",
              responce.data.season_start_date,
            );
            localStorage.setItem(
              "currentPlayingseasonEndDate",
              responce.data.season_end_date,
            );
          }

          ((this.season_start_date = responce.data.season_start_date),
            (this.season_end_date = responce.data.season_end_date));
          this.getThisSeasonsgamePerformanceReportsForUser();
          this.getTheLastDateSubmittedSeasonsTrainingPerformanceReport();
        }
        this.clubTeams = responce.data;

        return true;
      }
    },
    getNumberOfActionsForUser(data) {
      if (data.created_date === null) {
        return null;
      }
      this.playerActionNumber = 0;
      this.checkDateTimeFromNow(data.created_date) === true
        ? (this.playerActionNumber = this.playerActionNumber + 1)
        : (this.playerActionNumber = 0);
    },
    setPlayingSeasion() {
      if (isCalendarSeason()) {
        // Calendar-year seasons (e.g. Australia, played Mar-Sep): the
        // playing season is simply the current year - the early-year
        // weeks belong to the SAME year's season, not the previous one.
        this.currentPlayingSeason = moment().format("YYYY");
        localStorage.setItem("currentPlayingSeason", this.currentPlayingSeason);
        return;
      }
      if (this.weekSelectedNumber >= 8 && this.weekSelectedNumber < 52) {
        this.currentPlayingSeason = moment().format("YYYY");
      }
      if (this.weekSelectedNumber >= 1 && this.weekSelectedNumber < 8) {
        this.currentPlayingSeason = moment().subtract(1, "year").format("YYYY");
      }
      if (this.weekSelectedNumber == 52) {
        moment().format("M") === "1"
          ? (this.currentPlayingSeason = moment()
            .subtract(1, "year")
            .format("YYYY"))
          : (this.currentPlayingSeason = moment().format("YYYY"));
      }

      localStorage.setItem("currentPlayingSeason", this.currentPlayingSeason);
    },
    async populateCoachesData() {
      const coachesData = {
        clubId: this.userData.clubId,
        action: "populateCoachesData",
      };

      const responce = await Users.find(coachesData).catch((error) => {
        console.log(error);
      });

      return responce.data.length > 0 ? responce.data : [];
    },
    resetPlayerProfileForm() {
      this.playerProfileForm = {
        sectionOne: false,
        sectionTwo: false,
        sectionThree: false,
        sectionFour: false,
        sectionFive: false,
        sectionSix: false,
        sectionSeven: false,
        sectionEight: false,
      };
    },
    changePlayerProfileFormSection(section) {
      this.resetPlayerProfileForm();
      this.playerProfileFormSelection = section;
      this.playerProfileForm[section] = true;
    },
    formSectionsMove(type) {
      if (this.playerProfileFormSelection === "sectionOne" && type === "next") {
        this.changePlayerProfileFormSection("sectionTwo");
        return;
      }
      if (this.playerProfileFormSelection === "sectionTwo" && type === "next") {
        this.changePlayerProfileFormSection("sectionThree");
        return;
      }
      if (
        this.playerProfileFormSelection === "sectionThree" &&
        type === "next"
      ) {
        this.changePlayerProfileFormSection("sectionFour");
        return;
      }
      if (
        this.playerProfileFormSelection === "sectionFour" &&
        type === "next"
      ) {
        this.changePlayerProfileFormSection("sectionFive");
        return;
      }
      if (
        this.playerProfileFormSelection === "sectionFive" &&
        type === "next"
      ) {
        this.changePlayerProfileFormSection("sectionSix");
        return;
      }
      if (this.playerProfileFormSelection === "sectionSix" && type === "next") {
        this.changePlayerProfileFormSection("sectionSeven");
        return;
      }
      if (
        this.playerProfileFormSelection === "sectionSeven" &&
        type === "next"
      ) {
        this.changePlayerProfileFormSection("sectionEight");
        return;
      }
      if (
        this.playerProfileFormSelection === "sectionEight" &&
        type === "next"
      ) {
        return;
      }

      if (this.playerProfileFormSelection === "sectionTwo" && type === "back") {
        this.changePlayerProfileFormSection("sectionOne");
        return;
      }
      if (
        this.playerProfileFormSelection === "sectionThree" &&
        type === "back"
      ) {
        this.changePlayerProfileFormSection("sectionTwo");
        return;
      }
      if (
        this.playerProfileFormSelection === "sectionFour" &&
        type === "back"
      ) {
        this.changePlayerProfileFormSection("sectionThree");
        return;
      }
      if (
        this.playerProfileFormSelection === "sectionFive" &&
        type === "back"
      ) {
        this.changePlayerProfileFormSection("sectionFour");
        return;
      }
      if (this.playerProfileFormSelection === "sectionSix" && type === "back") {
        this.changePlayerProfileFormSection("sectionFive");
        return;
      }
      if (
        this.playerProfileFormSelection === "sectionSeven" &&
        type === "back"
      ) {
        this.changePlayerProfileFormSection("sectionSix");
        return;
      }
      if (
        this.playerProfileFormSelection === "sectionEight" &&
        type === "back"
      ) {
        this.changePlayerProfileFormSection("sectionSeven");
        return;
      }
    },
    async createPlayerProfile() { },
    async checkPlayerHasProfile() {
      if (
        this.userData.playerProfile === true ||
        this.userData.userType === "Admin" ||
        this.userData.userType === "Coach"
      ) {
        this.playerHasProfile = true;
        this.loadingStuff = false;
      } else {
        this.playerProfileData = {
          name: this.userData.name,
          email: this.userData.email,
          dob: this.userData.dob,
          position: this.userData.position,
        };
        this.coachData = await this.populateCoachesData();
        this.showPlayerProfileModalCall();
      }
    },
    showPlayerProfileModalCall() {
      this.loadingStuff = false;
      this.showModal("playerProfile");
    },
    tabChange(tabValue, selectedTabValue) {
      this[tabValue] = selectedTabValue;
    },
    async getUserById(clientId) {
      const userData = {
        clientId: clientId,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        this.userData = responce.data[0];
        const userData = responce.data[0];
        this.$store.dispatch(USER_POPULATE, { userData });
        return true;
      }
    },
    setUser() {
      if (this.getProfile !== null) {
        this.userData = this.getProfile;
      }
    },
    async getAllUsersForThisAdmin() {
      const userData = {
        coachId: this.userData.id,
        action: "getUserByCoachId",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        this.coachesUsersData = responce.data;
        this.$store.dispatch(POPULATE_COACHES_USER_DATA, this.coachesUsersData);
        localStorage.setItem(
          "coachesUsersData",
          JSON.stringify(this.coachesUsersData),
        );
      }
    },
    checkForCoachesUsersData() {
      if (this.getCoachesUsersData.length > 0) {
        this.coachesUsersData = this.getCoachesUsersData;
      } else {
        if (
          this.userData.userType === "Admin" ||
          this.userData.userType === "Coach"
        ) {
          this.getAllUsersForThisAdmin();
        }
      }
    },
    async getThisSeasonsgamePerformanceReportsForUser() {
      if (this.selectedUserValue === "") {
        this.selectedUserValue = this.userData.id;
      }
      if (localStorage.getItem("currentPlayingSeason") !== null) {
        this.currentPlayingSeason = localStorage.getItem(
          "currentPlayingSeason",
        );
      }
      const userData = {
        user_id: this.selectedUserValue,
        action: "getTheLastDateSubmittedSeasonsgamePerformanceReport",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
        year: this.currentPlayingSeason,
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.gamePerformanceData = responce.data[0];
        this.getNumberOfActionsForUser(this.gamePerformanceData);
      } else {
        this.playerActionNumber = this.playerActionNumber + 1;
      }
    },
    async getTheLastDateSubmittedSeasonsTrainingPerformanceReport() {
      if (this.selectedUserValue === "") {
        this.selectedUserValue = this.userData.id;
      }
      if (localStorage.getItem("currentPlayingSeason") !== null) {
        this.currentPlayingSeason = localStorage.getItem(
          "currentPlayingSeason",
        );
      }
      const userData = {
        user_id: this.selectedUserValue,
        action: "getTheLastDateSubmittedSeasonsTrainingPerformanceReport",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
        year: this.currentPlayingSeason,
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.trainingPerformanceData = responce.data[0];
        this.getNumberOfActionsForUser(this.trainingPerformanceData);
      } else {
        this.playerActionNumber = this.playerActionNumber + 1;
      }
    },
    checkDateTimeFromNow(date) {
      if (!date) {
        return false;
      }
      const otherDate = new Date(date);
      // Guard against unparseable dates (empty/garbled created_date) so this
      // never throws "Invalid time value" and breaks dashboard load.
      if (isNaN(otherDate.getTime())) {
        return false;
      }
      const now = new Date();
      const diffTime = Math.abs(
        new Date(now.setHours(0, 0, 0, 0)) -
        new Date(otherDate.setHours(0, 0, 0, 0)),
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays > 7 ? true : false;
    },
    showModal(modelId) {
      // Convert old modal IDs to new v-model properties
      const modalMap = {
        playerProfile: () => (this.showPlayerProfileModal = true),
        webPermmissionsModal: () => (this.showWebPermissionsModal = true),
        showMessageModal: () => (this.showMessageModal = true),
        showNotificationsNotSupportedModal: () =>
          (this.showNotificationsNotSupportedModal = true),
        showGrantPermissionsModal: () =>
          (this.showGrantPermissionsModal = true),
      };

      if (modalMap[modelId]) {
        modalMap[modelId]();
      }
    },
    hideModal(modelId) {
      // Convert old modal IDs to new v-model properties
      const modalMap = {
        playerProfile: () => (this.showPlayerProfileModal = false),
        webPermmissionsModal: () => (this.showWebPermissionsModal = false),
        showMessageModal: () => (this.showMessageModal = false),
        showNotificationsNotSupportedModal: () =>
          (this.showNotificationsNotSupportedModal = false),
        showGrantPermissionsModal: () =>
          (this.showGrantPermissionsModal = false),
      };

      if (modalMap[modelId]) {
        modalMap[modelId]();
      }
    },
    formatDate(date) {
      return moment(moment(date, "YYYY-MM-DD")).format("MMMM Do YYYY");
    },
    formatDateTime(date) {
      const m = moment(date, "YYYY-MM-DD HH:mm:ss");
      // Legacy rows were DATE-only (midnight) — don't show a fake time.
      return m.hours() === 0 && m.minutes() === 0
        ? m.format("MMMM Do YYYY")
        : m.format("MMMM Do YYYY, HH:mm");
    },
    /** Notices sent to the whole club or to one of this person's teams. */
    async getMyNotices() {
      const response = await Chat.find({
        action: "getMyNotices",
        clubId: this.userData.clubId,
        userId: this.userData.id,
      }).catch((error) => {
        console.log(error);
      });
      if (response && response.status === 200 && Array.isArray(response.data)) {
        this.myNotices = response.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* --- Flutter-style dashboard app tiles ("Your Apps") --- */
/* Responsive card grid: 2-ish columns on mobile, more on desktop. */
.tabs-wrapper .current-week-tab.tab-content {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;
}

.current-week-tab .training-session-entry {
  margin: 0;
  width: auto;
  max-width: none;
  background: #fff;
  border: 1px solid #eeeeee;
  border-radius: 18px;
  box-shadow: none;
  padding: 30px;
  cursor: pointer;
  transition: box-shadow 0.18s ease, border-color 0.18s ease,
    transform 0.18s ease;
}

.current-week-tab .training-session-entry:hover,
.current-week-tab .training-session-entry:focus-within {
  border-color: color-mix(in srgb, var(--brand-color) 40%, #eeeeee);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

/* Centre the tile contents (icon on top, label below). */
.current-week-tab .session-content.large-app,
.current-week-tab .session-content.large-app a {
  display: block;
  text-align: center;
  margin: 0;
}

.current-week-tab .session-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  margin: 0;
}

.current-week-tab .session-data h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.3;
  color: #212121;
  text-transform: none;
  letter-spacing: normal;
}

.survey-link {
  border: 1px solid #bab8b8;
  padding: 2rem;
  margin-bottom: 2rem;
  background: #ffffff;
  border-radius: 4px;

  p {
    margin: 0;
  }

  a {
    border: 1px solid #15a159;
    padding: 1rem;
    margin-top: 1rem;
    display: block;
    text-decoration: none;
    cursor: pointer;
    width: 16rem;
    border-radius: 4px;
    background: #16a159;
    color: white;
    font-weight: bold;

    &:hover {
      background: #22b167;
    }
  }
}

.notifications-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  padding: 1rem;
  align-items: start;
}

@media screen and (min-width: 1100px) {
  .notifications-grid {
    grid-template-columns: minmax(0, 34rem) minmax(0, 1fr);
  }

  /* Players only see the history card — let it use the full row. */
  .notifications-grid>.notifications-history:only-child {
    grid-column: 1 / -1;
    max-width: 46rem;
  }
}

.notify-card {
  border: 1px solid #e2e7e4;
  border-radius: 6px;
  background: #fbfcfb;
  padding: 1.25rem 1.5rem;

  .notify-card__title {
    font-size: 1.05rem;
    margin: 0 0 1rem;
  }

  .form__item {
    margin-bottom: 1rem;
  }

  .form__label {
    display: block;
    font-weight: 600;
    margin-bottom: 0.35rem;
  }

  .form__hint {
    display: block;
    margin-top: 0.25rem;
    color: #6b7a85;
  }

  .field-hint {
    font-size: 0.85rem;
    color: #6b7a85;
    margin: 0.25rem 0 0;
  }

  .selected-count {
    font-weight: 400;
    font-size: 0.8rem;
    color: #1d7a3a;
    background: #e6f4ea;
    border-radius: 999px;
    padding: 1px 8px;
    margin-left: 0.5rem;
  }
}

.channel-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;

  .channel-option {
    flex: 1 1 12rem;
    border: 1px solid #c9d3cd;
    border-radius: 6px;
    padding: 0.6rem 0.9rem;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
    margin: 0;
    background: #fff;

    input {
      position: absolute;
      opacity: 0;
      pointer-events: none;
    }

    .channel-option__name {
      font-weight: 600;
    }

    .channel-option__hint {
      font-size: 0.8rem;
      color: #6b7a85;
    }

    &.selected {
      border-color: #16a159;
      box-shadow: inset 0 0 0 1px #16a159;
      background: #f2f9f3;
    }
  }
}

.emergency-check {
  i {
    color: #c9a13c;
  }

  &.armed {
    color: #c03540;
    font-weight: 600;

    i {
      color: #c03540;
    }
  }
}

.team-choices {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;

  .team-choice {
    border: 1px solid #c9d3cd;
    border-radius: 999px;
    padding: 0.3rem 0.9rem;
    cursor: pointer;
    margin: 0;
    font-size: 0.9rem;
    background: #fff;

    input {
      position: absolute;
      opacity: 0;
      pointer-events: none;
    }

    &.selected {
      background: #16a159;
      border-color: #16a159;
      color: #fff;
      font-weight: 600;
    }
  }
}

.notify-send {
  min-width: 14rem;
}

.notifications-history {
  .history-empty {
    color: #6b7a85;
    font-style: italic;
  }

  .scroll-wrapper {
    max-height: min(65vh, 42rem);
    overflow-y: auto;
    padding-right: 0.25rem;
  }

  .history-list {
    background: #fff;
    border: 1px solid #e2e7e4;
    border-left: 3px solid #b9c4bd;
    padding: 0.85rem 1rem;
    border-radius: 4px;
    margin-bottom: 0.75rem;

    &.is-emergency {
      border-left-color: #c03540;
      background: #fdf7f7;
    }

    .date {
      font-size: 0.8rem;
      color: #6b7a85;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.4rem;
    }

    .badge-emergency {
      background: #fdecee;
      color: #c03540;
      font-size: 0.7rem;
      font-weight: 700;
      border-radius: 999px;
      padding: 1px 8px;
    }

    .badge-channel {
      background: #eef1f3;
      color: #46545f;
      font-size: 0.7rem;
      font-weight: 600;
      border-radius: 999px;
      padding: 1px 8px;
    }

    .title {
      font-weight: bold;
      margin-top: 0.25rem;
    }

    .body {
      margin-top: 0.25rem;
      white-space: pre-line;
    }

    .meta {
      margin-top: 0.4rem;
      font-size: 0.8rem;
      color: #6b7a85;
    }

    p {
      margin: 0;
    }
  }
}

/* Nutrition icon placeholder for dashboard */
.nutrition-icon-placeholder {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #28a745, #20c997);
  border-radius: 12px;
  margin-bottom: 8px;

  .nutrition-icon {
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
  }
}

/* iOS Home Screen Prompt Modal Styles */
.ios-prompt-content {
  padding: 0.5rem;
}

.ios-prompt-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.ios-prompt-icon {
  margin-bottom: 1rem;
}

.ios-prompt-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #1d1d1f;
  margin-bottom: 0.5rem;
}

.ios-prompt-subtitle {
  font-size: 1rem;
  color: #6e6e73;
  margin: 0;
  line-height: 1.4;
}

.ios-prompt-steps {
  background: #f5f5f7;
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.ios-step {
  display: flex;
  align-items: flex-start;
  padding: 0.75rem 0;

  &:not(:last-child) {
    border-bottom: 1px solid #e5e5e7;
  }
}

.ios-step-number {
  width: 28px;
  height: 28px;
  background: #007AFF;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.9rem;
  flex-shrink: 0;
  margin-right: 0.75rem;
}

.ios-step-content {
  flex: 1;
}

.ios-step-text {
  margin: 0;
  font-size: 0.95rem;
  color: #1d1d1f;
  line-height: 1.5;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem;

  strong {
    color: #007AFF;
  }
}

.ios-share-icon {
  display: inline-block;
  vertical-align: middle;
  margin: 0 0.25rem;
}

.ios-prompt-note {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #e8f4fd;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  color: #0066cc;
  font-size: 0.9rem;
}

.ios-prompt-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.ios-prompt-btn {
  width: 100%;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;

  &:active {
    transform: scale(0.98);
  }
}

.ios-prompt-btn-primary {
  background: #007AFF;
  color: white;

  &:hover {
    background: #0066d6;
  }
}

.ios-prompt-btn-secondary {
  background: transparent;
  color: #6e6e73;
  border: 1px solid #d2d2d7;

  &:hover {
    background: #f5f5f7;
  }
}

/* Generic Notifications Modal Styles */
.notifications-modal-content {
  padding: 0.5rem;
}

.notifications-modal-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.notifications-modal-icon {
  margin-bottom: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
}

.notifications-modal-icon--warning {
  background: #fff3cd;
  color: #856404;
}

.notifications-modal-icon--info {
  background: #e8f4fd;
  color: #007AFF;
}

.notifications-modal-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #1d1d1f;
  margin-bottom: 0.5rem;
}

.notifications-modal-subtitle {
  font-size: 1rem;
  color: #6e6e73;
  margin: 0;
  line-height: 1.4;
}

.notifications-modal-info {
  background: #f5f5f7;
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.notifications-info-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  font-size: 0.95rem;
  color: #1d1d1f;

  &:not(:last-child) {
    border-bottom: 1px solid #e5e5e7;
    padding-bottom: 0.75rem;
    margin-bottom: 0.5rem;
  }

  strong {
    color: #007AFF;
  }
}

.notifications-modal-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.notifications-modal-btn {
  width: 100%;
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;

  &:active {
    transform: scale(0.98);
  }
}

.notifications-modal-btn--primary {
  background: #007AFF;
  color: white;

  &:hover {
    background: #0066d6;
  }
}

.notifications-modal-btn--secondary {
  background: transparent;
  color: #6e6e73;
  border: 1px solid #d2d2d7;

  &:hover {
    background: #f5f5f7;
  }
}
</style>
